module.exports = __webpack_public_path__ + "img/icon_searchGray.b98da836.svg";